import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 15000 });

export async function fetchProfile() {
    const { data } = await api.get("/profile");
    return data;
}

export async function updateProfile(patch) {
    const { data } = await api.put("/profile", patch);
    return data;
}

export async function recordMatch(payload) {
    const { data } = await api.post("/matches", payload);
    return data;
}

export async function fetchMatches(limit = 20) {
    const { data } = await api.get("/matches", { params: { limit } });
    return data;
}

export async function fetchNews() {
    const { data } = await api.get("/news");
    return data;
}

export async function fetchStats() {
    const { data } = await api.get("/stats");
    return data;
}
